import React from 'react'
import { Card, Skeleton, Row, Col } from 'antd'

interface SectionSkeletonProps {
  rows?: number
  cols?: number
  showTitle?: boolean
  variant?: 'card' | 'text' | 'stat'
}

/**
 * 骨架屏组件 - 用于页面加载占位
 */
const SectionSkeleton: React.FC<SectionSkeletonProps> = ({
  rows = 3,
  cols = 3,
  showTitle = true,
  variant = 'card'
}) => {
  if (variant === 'stat') {
    return (
      <Row gutter={[32, 32]}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Col xs={12} sm={6} key={index}>
            <Card>
              <Skeleton active paragraph={{ rows: 1 }} />
            </Card>
          </Col>
        ))}
      </Row>
    )
  }

  if (variant === 'text') {
    return (
      <div className="space-y-4">
        {showTitle && <Skeleton active title={{ width: '60%' }} paragraph={false} />}
        {Array.from({ length: rows }).map((_, index) => (
          <Skeleton key={index} active paragraph={{ rows: 2 }} />
        ))}
      </div>
    )
  }

  return (
    <div>
      {showTitle && (
        <div className="text-center mb-12">
          <Skeleton active title={{ width: '40%' }} paragraph={{ rows: 1, width: '60%' }} />
        </div>
      )}
      <Row gutter={[24, 24]}>
        {Array.from({ length: cols }).map((_, index) => (
          <Col xs={24} sm={12} md={24 / cols} key={index}>
            <Card>
              <Skeleton active avatar paragraph={{ rows }} />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default SectionSkeleton

